<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && building">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<table
							class="table"
							*ngIf="building">
							<tbody>
								<tr *ngIf="building.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ building.id }}</td>
								</tr>
								<tr *ngIf="building.name">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ building.name }}</td>
								</tr>
								<tr *ngIf="company.name">
									<td>{{'labels.company' | translate }}</td>
									<td>{{ company.name }}</td>
								</tr>
								<tr *ngIf="building.buildingtype">
									<td>{{ 'labels.type' | translate }}</td>
									<td>{{ building.buildingtype | titlecase }}</td>
								</tr>
								<tr *ngIf="building.address">
									<td>{{ 'labels.address' | translate }}</td>
									<td>{{ building.address }}</td>
								</tr>
								<tr *ngIf="building.streetno">
									<td>{{ 'labels.streetno' | translate }}</td>
									<td>{{ building.streetno }}</td>
								</tr>
								<tr *ngIf="building.city">
									<td>{{ 'labels.city' | translate }}</td>
									<td>{{ building.city }}</td>
								</tr>
								<tr *ngIf="building.province">
									<td>{{ 'labels.province' | translate }}</td>
									<td>{{ building.province }}</td>
								</tr>
								<tr *ngIf="building.zipcode">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ building.zipcode }}</td>
								</tr>
								<tr *ngIf="building.bondtype">
									<td>{{ 'labels.bondtype' | translate }}</td>
									<td>
										{{('labels.' + building.bondtype | translate)}}
									</td>
								</tr>
								<tr *ngIf="building.leasingfee">
									<td>{{ 'labels.leasingfee' | translate }}</td>
									<td>
										{{building?.isLeasing ? (building.leasingfee | currency:"EUR") : '-'}}
									</td>
								</tr>
								<tr *ngIf="building.value && building?.isPurchase">
									<td>{{ 'labels.value' | translate }}</td>
									<td>
										{{building?.isPurchase ? (building.value | currency:"EUR") : '-'}}
									</td>
								</tr>
								<tr *ngIf="building.yearlyvalue">
									<td>{{ 'labels.yearlyvalue' | translate }}</td>
									<td>
										{{ building.yearlyvalue | currency:'EUR' }}
									</td>
								</tr>

								<tr *ngIf="building.depreciationstart && building?.isPurchase">
									<td>
										{{'labels.depreciationstart' | translate }}
									</td>
									<td>
										{{building?.isPurchase ? (building.depreciationstart | date:"dd/MM/yyyy") : '-'}}
									</td>
								</tr>
								<tr *ngIf="building.depreciationend && building?.isPurchase">
									<td>
										{{'labels.depreciationend' | translate }}
									</td>
									<td>
										{{building?.isPurchase ? (building.depreciationend | date:"dd/MM/yyyy") : '-'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ building.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<div class="row mt-1">
									<div class="col">
										<button
											(click)="edit()"
											class="btn btn-primary">
											{{'labels.edit' | translate | titlecase}}
										</button>
									</div>
								</div>
							</tbody>
						</table>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : company?.id}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="building"
							[bootstrap]="true"
							[eid]="building.id"></app-attachments>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="utilization">
					<a
						routerLink="."
						fragment="utilization"
						ngbNavLink>
						Utilizzo
					</a>
					<ng-template ngbNavContent>
						<app-building-activity-use [building]="building"></app-building-activity-use>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.building' | translate}}
		</app-card>

	</div>
</div>
